document.addEventListener('click', function(e) {
  const btn = e.target.closest('.sbc-add-to-cart-btn, .sbc-modal-add-cart');
  if (!btn) return;

  setTimeout(() => {
    document.dispatchEvent(new Event('cart:refresh'));
    document.dispatchEvent(new Event('cart:open'));
  }, 500);
});